import axios from "axios";
import store from "@/store";
import { router } from "../router";
import qs from 'qs'
import Mutex from '../store/mutex'
import { ErrorService } from "../helpers/errorplugin"

const $log = ErrorService
const mutex = new Mutex();

//axios.defaults.headers.post["Content-type"] = "application/json"

let apiserver = location.protocol + "//" + location.hostname

if ("development" === process.env.NODE_ENV )
    apiserver += ":8080"

let portalapiurl = new URL('/portalapi', apiserver)
const portalapi = axios.create({
    baseURL: portalapiurl.toString()
})


let cpdurl = new URL( "https://cpd.soldiernet.co.uk/")
const cpdapi = axios.create({
    baseURL: cpdurl.toString()
})

export {
    portalapi,
    cpdapi,
    mutex
}

export function axiosSetUp() {
    
    // Add a request interceptor
    portalapi.interceptors.request.use(
        function(config) {
            config.paramsSerializer = function (params) {
                return qs.stringify(params, { arrayFormat: 'repeat'})
            }
            // Do something before request is sent
            const token = store.getters['account/accessToken'];
            if (token && !config.url.includes("jwt/refresh/") && !config.url.includes("jwt/create/")) {
                config.headers.Authorization = `Bearer ${token}`;
            }
            return config;
        },
        function(error) {
            // Do something with request error
            return error// return Promise.reject(error);
        }
    );

    // Add a response interceptor
    portalapi.interceptors.response.use(
        response => response,
        async error => {
        const originalRequest = error.config;
           
        if ( error.response.status === 401 && originalRequest.url.includes("jwt/refresh")) {
            $log.onDebug("got a 401 on a jwt/refresh url")
            return Promise.reject(error);
        } else if ( error.response.status === 401 && originalRequest.url.includes("jwt/create")) {
            $log.onDebug("got a 401 on a jwt/create url")
            return Promise.reject(error);
        } else if (error.response.status === 401 && !originalRequest._retry) {
          originalRequest._retry = true;
    
          $log.onTrace('got a 401 not on a retry on:' + originalRequest.url);
          $log.onTrace('Lock state:' + mutex.isLocked() + " Q: " + mutex.queueLength());
    
          let rt = store.getters['account/refreshToken'] 
          await mutex.acquire(); // Acquire the lock
          $log.onTrace('Lock acquired');
    
          try {
    
              // if no other task has done a refresh yet
              if ( rt == store.getters['account/refreshToken'] ){
    
                $log.onTrace('calling refresh in src helpers axios');
                // Call the refresh token endpoint (/jwt/refresh) to get a new access token
                const response = await portalapi.post('jwt/refresh', {
                    refresh: store.getters['account/refreshToken']                      
                });
                
                $log.onTrace('refresh completed');
                store.commit("account/setRefreshToken", response.data.refresh);
                store.commit("account/setAccessToken", response.data.token);
              }
    
              // Retry the original request with the new access token
              originalRequest.headers['Authorization'] = `Bearer ${store.getters['account/accessToken']}`;
    
              $log.onTrace('return a rerun of the original:' + originalRequest.url);
              return axios(originalRequest);
          } catch (error) {
            // Handle errors
            // For example, log the user out or redirect to the login page
            // THIS NEEDS CHECKED AS IT MIGHT NOT HAVE BEEN A REFRESH THAT FAILED HERE
            $log.onDebug("Fail:" + error.config.url)
            // THE axois(originalRequest) may have been at fault
            $log.onTrace('Refresh token failed:', error);
            store.commit("account/clearUserData", "")
    
            // Redirect to the login page or perform other actions
            router.push("/pages/login");
          } finally {
            $log.onTrace('Releasing:' + originalRequest.url);
            mutex.release(); // Release the lock
            $log.onTrace('Lock released:' + originalRequest.url);
          }
        }
    
        return Promise.reject(error);
        }                 
    );
}


